import { type SxProps, type Theme } from "@mui/material";

export type MatchStatusCategory = "UPCOMING" | "LIVE" | "FINISHED";

export type MatchStatusFilter = MatchStatusCategory | "ALL";

export const normalizeMatchStatus = (status?: string): MatchStatusCategory => {
  if (!status || status === "UPCOMING") return "UPCOMING";
  if (status === "LIVE") return "LIVE";
  if (status === "FINISHED" || status === "COMPLETED") return "FINISHED";
  return "UPCOMING";
};

export const MATCH_STATUS_LABELS: Record<MatchStatusCategory, string> = {
  UPCOMING: "Tuleva",
  LIVE: "Live",
  FINISHED: "Pelattu",
};

export const MATCH_STATUS_FILTER_OPTIONS: MatchStatusFilter[] = [
  "ALL",
  "UPCOMING",
  "LIVE",
  "FINISHED",
];

export const getMatchStatusFilterLabel = (filter: MatchStatusFilter, count?: number): string => {
  if (filter === "ALL") {
    return count === undefined ? "Kaikki" : `Kaikki (${String(count)})`;
  }

  const label = MATCH_STATUS_LABELS[filter];
  return count === undefined ? label : `${label} (${String(count)})`;
};

export const matchStatusFilterChipSx = (selected: boolean): SxProps<Theme> => ({
  fontSize: "0.8rem",
  height: 28,
  ...(selected ? { fontWeight: 600 } : undefined),
});
